import React from "react";
import "./typinggame/TypingGame.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {StoryRoute} from "./typinggame/StoryRoute";
import {StoryLibrary} from "./StoryLibrary/StoryLibrary";
import {StoryFocus} from "./StoryLibrary/StoryFocus";
import AdultGate from "./Elements/AdultGate";

const App: React.FC = () => {
    return <React.StrictMode>
        <BrowserRouter>
            <AdultGate redirectUrl="https://google.com" minAge={18} />
            <Routes>
                <Route path="/" element={<StoryLibrary />} />
                <Route path="/book/:storyKey" element={<StoryFocus />} />
                <Route path="/play/:storyKey" element={<StoryRoute />} />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>
};

export default App;
